import { RiskChance } from 'src/Enum/GoalsAndOperationalPlans';
import { IInfoCategoryMasterData } from './MasterData';

const RISK_CATEGORIES = {
  STRATEGIC: 'ความเสี่ยงด้านกลยุทธ์และการประกอบธุรกิจ (Strategic Risk)',
  OPERATIONAL:
    'ความเสี่ยงด้านการบริหารจัดการและการปฏิบัติงาน (Operational Risk)',
  COMPLIANCE: 'ความเสี่ยงด้านกฎระเบียบและกฎหมาย (Compliance Risk)',
  FINANCIAL: 'ความเสี่ยงด้านการเงิน (Financial Risk)',
} as const;

export const OTHER_TITLE_MAPPING: Record<string, string> = {
  [RISK_CATEGORIES.STRATEGIC]: 'ความเสี่ยงด้านกลยุทธ์และการประกอบธุรกิจอื่น ๆ',
  [RISK_CATEGORIES.OPERATIONAL]:
    'ความเสี่ยงด้านการบริหารจัดการและการปฏิบัติงานอื่น ๆ',
  [RISK_CATEGORIES.COMPLIANCE]: 'ความเสี่ยงด้านกฎระเบียบและกฎหมายอื่น ๆ',
  [RISK_CATEGORIES.FINANCIAL]: 'ความเสี่ยงด้านการเงินอื่น ๆ',
};

export const CATEGORY_TITLES: Record<string, { th: string; en: string }> = {
  STRATEGIC_RISK: {
    th: 'ความเสี่ยงด้านกลยุทธ์และการประกอบธุรกิจ',
    en: 'Strategic Risk',
  },
  OPERATIONAL_RISK: {
    th: 'ความเสี่ยงด้านการบริหารจัดการและการปฏิบัติงาน',
    en: 'Operational Risk',
  },
  COMPLIANCE_RISK: {
    th: 'ความเสี่ยงด้านกฎระเบียบและกฎหมาย',
    en: 'Compliance Risk',
  },
  FINANCIAL_RISK: {
    th: 'ความเสี่ยงด้านการเงิน',
    en: 'Financial Risk',
  },
};

export const riskChanceOptions = [
  { label: 'สูง', value: RiskChance.HIGH },
  { label: 'กลาง', value: RiskChance.MEDIUM },
  { label: 'ต่ำ', value: RiskChance.LOW },
];

export enum INFO_CATEGORY_RISK_RELATED {
  STRATEGIC_RISK = 'STRATEGIC_RISK',
  OPERATIONAL_RISK = 'OPERATIONAL_RISK',
  COMPLIANCE_RISK = 'COMPLIANCE_RISK',
  FINANCIAL_RISK = 'FINANCIAL_RISK',
}

export const riskOrder = [
  INFO_CATEGORY_RISK_RELATED.STRATEGIC_RISK,
  INFO_CATEGORY_RISK_RELATED.OPERATIONAL_RISK,
  INFO_CATEGORY_RISK_RELATED.COMPLIANCE_RISK,
  INFO_CATEGORY_RISK_RELATED.FINANCIAL_RISK,
];

export type SelectedRisks = Record<string, IInfoCategoryMasterData[]>;
